module.exports = __webpack_public_path__ + "img/d64418c6fdd299e3375426f6ce043fcc.png";